// class CartRemoveButton extends HTMLElement {
//   constructor() {
//     super();

//     this.addEventListener('click', async(event) => {
//       event.preventDefault();

//       const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
//       console.log('removed func called');

//       var giftitem1 = this.querySelector('button').getAttribute('data-gift-1');
//       var giftitem2 = this.querySelector('button').getAttribute('data-gift-2');
//       var giftsToRemove = [];
//         if (giftitem1 && giftitem1.trim() !== "") giftsToRemove.push(giftitem1);
//         if (giftitem2 && giftitem2.trim() !== "") giftsToRemove.push(giftitem2);

//         if (giftsToRemove.length > 0) {
//           console.log('giftsToRemove',giftsToRemove);
//           checkAndRemove(giftsToRemove); // pass only the non-empty ones
//         }

//       cartItems.updateQuantity(this.dataset.index, 0);
//       await new Promise(r => setTimeout(r, 500));
       

//       //checkAndRemove();
//     });
//   }
// }

//remove function
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', async (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      console.log('removed func called');
      const itemKey = this.getAttribute('data-cart-key');
      const giftitem1 = this.querySelector('button').getAttribute('data-gift-1');
      const giftitem2 = this.querySelector('button').getAttribute('data-gift-2');

      if (giftitem1 || giftitem2) {
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        const items = cart.items || [];
        const matchingItems = items.filter(item => 
          item.properties &&
          item.properties['Parent Gift 1'] == giftitem1 &&
          item.properties['Parent Gift 2'] == giftitem2
        );
        console.log('Matching items count:', matchingItems.length);
        if (matchingItems.length === 1) {
          const giftsToRemove = [];
          if (giftitem1 && giftitem1.trim() !== "") giftsToRemove.push(giftitem1);
          if (giftitem2 && giftitem2.trim() !== "") giftsToRemove.push(giftitem2);

          if (giftsToRemove.length > 0) {
            console.log('Removing gifts because last matching item is being removed:', giftsToRemove); 
            if (itemKey) {
              console.log('Removing main product with key:', itemKey);
              await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: itemKey, quantity: 0 })
              });
            }
            checkAndRemove(giftsToRemove); 
          }
        } else {
          console.log('Other products with same gift exist — skip gift removal');
        }
      }

      cartItems.updateQuantity(this.dataset.index, 0);
      await new Promise(r => setTimeout(r, 500));
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceQty = html.querySelector('cart-items');
        this.innerHTML = sourceQty.innerHTML;
      })
      .catch((e) => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

// const checkAndRemove = async () => {
//   const subscriptionVariantId = "41300849819728";
//   console.log('Fetching cart items...');

//   // Optional delay before fetching (could be useful if waiting for cart updates)
//   await new Promise(r => setTimeout(r, 500));

//   const cartRes = await fetch('/cart.js', {
//     method: "GET"
//   });

//   const cart = await cartRes.json();
//   const items = cart.items || [];

//   // Identify subscription items
//   const subscriptionItems = items.filter(item => {
//     const props = item.properties || {};
    
//     // Check for known subscription flags
//     return item.selling_plan_allocation !== null || 
//           props._subscription === 'true' ||
//           props.isSubscription === 'Yes' || 
//           Object.keys(props).some(k => k.toLowerCase().includes('subscription'));
//   });
//   const hasSellingPlanAllocation = items.some(item => 'selling_plan_allocation' in item);
//   console.log("hasSellingPlanAllocation",hasSellingPlanAllocation)


//   console.log('Cart Items:', items);
//   console.log('Subscription Items:', subscriptionItems);

//   // If no subscriptions, remove target product
//   if (!hasSellingPlanAllocation) {
//     console.log(`No subscriptions found. Checking for variant ID: ${subscriptionVariantId}`);

//     // Find item with the target variant ID
//     const itemToRemove = items.find(item => item.variant_id.toString() === subscriptionVariantId);

//     console.log("Item to remove:", itemToRemove);

//     if (itemToRemove) {
//       const removeRes = await fetch('/cart/change.js', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json'
//         },
//         body: JSON.stringify({
//           id: itemToRemove.key,
//           quantity: 0
//         })
//       });

//       const removeResult = await removeRes.json();
//       $('#CartDrawer-CartItems').load(location.href + ' #CartDrawer-CartItems > *');
//       console.log(`Removed item with variant ID ${subscriptionVariantId}`, removeResult);
//     } else {
//       console.log(`Item with variant ID ${subscriptionVariantId} not found in cart.`);
//     }

//     return false;
//   }

//   console.log('Subscription(s) present. No removal needed.');
//   return true;
// };

// const checkAndRemove = async (giftsToRemove) => {
//  // const subscriptionVariantId = giftsToRemove;
//   const subscriptionVariantId = "41300849819728";
//   console.log('Fetching cart items...',subscriptionVariantId);

//   // Optional delay before fetching (could be useful if waiting for cart updates)
//   await new Promise(r => setTimeout(r, 500));

//   const cartRes = await fetch('/cart.js', {
//     method: "GET"
//   });

//   const cart = await cartRes.json();
//   const items = cart.items || [];

//   // Identify subscription items
//   const subscriptionItems = items.filter(item => {
//     const props = item.properties || {};
    
//     // Check for known subscription flags
//     return item.selling_plan_allocation !== null || 
//           props._subscription === 'true' ||
//           props.isSubscription === 'Yes' || 
//           Object.keys(props).some(k => k.toLowerCase().includes('subscription'));
//   });
//   const hasSellingPlanAllocation = items.some(item => 'selling_plan_allocation' in item);
//   console.log("hasSellingPlanAllocation",hasSellingPlanAllocation)


//   console.log('Cart Items:', items);
//   console.log('Subscription Items:', subscriptionItems);

//   // If no subscriptions, remove target product
//   if (!hasSellingPlanAllocation) {
//     console.log(`No subscriptions found. Checking for variant ID: ${subscriptionVariantId}`);

//     // Find item with the target variant ID
//     const itemToRemove = items.find(item => item.variant_id.toString() === subscriptionVariantId);

//     console.log("Item to remove:", itemToRemove);

//     if (itemToRemove) {
//       const removeRes = await fetch('/cart/change.js', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json'
//         },
//         body: JSON.stringify({
//           id: itemToRemove.key,
//           quantity: 0
//         })
//       });

//       const removeResult = await removeRes.json();
//       $('#CartDrawer-CartItems').load(location.href + ' #CartDrawer-CartItems > *');
//       console.log(`Removed item with variant ID ${subscriptionVariantId}`, removeResult);
//     } else {
//       console.log(`Item with variant ID ${subscriptionVariantId} not found in cart.`);
//     }

//     return false;
//   }

//   console.log('Subscription(s) present. No removal needed.');
//   return true;
// };

async function checkAndRemove(giftsToRemove) {
  console.log('Fetching cart items to remove gifts...');

  const cartRes = await fetch('/cart.js');
  const cart = await cartRes.json();
  const items = cart.items || [];

  // Find all items that match any of the gift variant IDs
  const itemsToRemove = items.filter(item =>
    giftsToRemove.includes(item.variant_id.toString())
  );

  if (itemsToRemove.length === 0) {
    console.log('No matching gift items found.');
    return;
  }

  // Remove each one
  for (const gift of itemsToRemove) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: gift.key,
        quantity: 0
      })
    });
    console.log('Removed gift variant:', gift.variant_id);
  }

  console.log('All selected gifts removed.');
  
    fetch(`${routes.cart_url}?sections=cart-drawer`)
      .then((response) => response.json())
      .then((sections) => {
        const sectionIds = ['cart-drawer'];
        for (const sectionId of sectionIds) {
          const htmlString = sections[sectionId];
          const html = new DOMParser().parseFromString(htmlString, 'text/html');
          const sourceElement = html.querySelector(`${sectionId}`);
          const targetElement = document.querySelector(`${sectionId}`);
          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          }
        }
        document.body.classList.add('overflow-hidden');
        const theme_cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (theme_cart && theme_cart.classList.contains('is-empty')) theme_cart.classList.remove('is-empty');
        theme_cart.classList.add('active');

        thiss.find('.loading-overlay__spinner').addClass('hidden'); 
        thiss.find('.textArea_options').show();
        
      })
       
       const updatedCartRes = await fetch('/cart.js');
      const updatedCart = await updatedCartRes.json();

      if (updatedCart.item_count === 0) {
        console.log('Cart is empty — showing warnings.');
        const warningEl = document.querySelector('cart-drawer:not(.is-empty) .cart-drawer__warnings');
        if (warningEl) warningEl.style.display = 'flex';
      }
}

